/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { UserRequest } from "../models/userRequestResponse.interface";
import { SignUpService } from "../authServices/signup.service";
import { Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { VerificationComponent } from "../verification/verification.component";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from "@angular/material/dialog";
import { SigninComponent } from "../signin/signin.component";
import { PRIVACY_POLICY } from "src/environments/config";
import { icons } from "src/environments/config";

const EMAIL_PHONE_VALIDATION_EXPRESION =
  "^[0-9]{10}$|^[_a-zA-Z0-9]+(.[_a-zA-Z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$";
@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.scss"],
})
export class SignupComponent implements OnInit {
  signUpForm = new FormGroup({
    userName: new FormControl("", [
      Validators.required,
      this.noWhitespaceValidator,
    ]),
    userDetails: new FormControl("", [
      Validators.required,
      Validators.pattern(EMAIL_PHONE_VALIDATION_EXPRESION),
    ]),
    userPassword: new FormControl("", [
      Validators.required,
      Validators.minLength(8),
    ]),
  });
  userRequest: UserRequest = {
    username: "",
    displayName: "",
    password: "",
    issendotp: false,
    type: "",
    applicationName: "",
  };
  user: string;
  userEmailCheck: RegExp = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
  userPhoneCheck: RegExp = /^[0-9]{10}$/;
  userError: boolean = false;
  userErrorMessage: string;
  passwordType = "password";
  passwordImg = icons.whiteShopIcon.eyeSlash;
  passwordVisibility = false;

  constructor(
    private signUpService: SignUpService,
    private dialog: MatDialog,
    private dialogSignIn: MatDialogRef<SigninComponent>
  ) {}
  ngOnInit() {}

  // Start of get functions for signup form fields
  get userName() {
    return this.signUpForm.get("userName");
  }
  get userDetails() {
    return this.signUpForm.get("userDetails");
  }
  get userPassword() {
    return this.signUpForm.get("userPassword");
  }
  // End of get functions for signup form fields
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  verificationFunction() {
    if (this.userEmailCheck.test(this.signUpForm.value.userDetails)) {
      this.userRequest.username = this.signUpForm.value.userDetails;
    } else if (this.userPhoneCheck.test(this.userDetails.value)) {
      this.userRequest.username = this.signUpForm.value.userDetails;
    }
    if (this.signUpForm.value.userName) {
      this.userRequest.displayName = this.signUpForm.value.userName.trim();
    }
    this.userRequest.password = this.userPassword.value;
    this.userRequest.issendotp = true;
    this.userRequest.type = "B2C";
    this.userRequest.applicationName = window.location.hostname;
    this.signUpService.signUp(this.userRequest).subscribe(
      (json: any) => {
        this.handleSuccess(json);
        this.dialogSignIn.close();
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = false;
        dialogConfig.hasBackdrop = true;
        dialogConfig.maxWidth = "100vw";
        dialogConfig.width = "100vw";
        dialogConfig.panelClass = "override";
        dialogConfig.position = {
          top: "0",
          left: "0",
        };
        this.dialog.open(VerificationComponent, dialogConfig);
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  handleSuccess(json: any) {
    let userResponse: any;
    userResponse = json;

    if (userResponse.status === true) {
      this.signUpService.sendSignUpResponse(json);
      let userDetails: string;
      if (json.user.email) {
        userDetails = json.user.email;
      } else if (json.user.mobile) {
        userDetails = json.user.mobile;
      }
    }
  }

  // display of error message
  handleError(error) {
    this.userError = true;
    this.userErrorMessage = error.error.message;
  }

  // displaying password to user
  togglePasswordVisibility() {
    if (this.passwordType === "text") {
      this.passwordType = "password";
      this.passwordImg = icons.whiteShopIcon.eyeSlash;
      this.passwordVisibility = false;
    } else {
      this.passwordType = "text";
      this.passwordImg = icons.whiteShopIcon.eye;
      this.passwordVisibility = true;
    }
  }

  // validating the credenatials
  validCredentials() {
    return (
      this.signUpForm.controls.userName.valid &&
      this.signUpForm.controls.userDetails.valid &&
      this.signUpForm.controls.userPassword.valid
    );
  }

  submit() {
    // if form is valid,user is navigated to verification  page
    if (!this.signUpForm.invalid) {
      this.verificationFunction();
    }
  }
  redirectPrivacyPolicy() {
    window.open(PRIVACY_POLICY);
  }
}
